<template>
  <div class="generic-article">
    <div class="container margin-auto-inline">
      <card :title="false">
        <generic-content-loader :async-status="asyncStatus" :target="item">
          <template #default>
            <div v-if="item">
              <h1>{{ item.title }}</h1>
              <div v-for="(section,index) of item.sections" :class="{'margin-max-bottom' : index < item.sections.length - 1}">
                <h2 v-if="isNonEmptyString(section.title)">{{ section.title }}</h2>
                <content-blocks :content="section.content"></content-blocks>
              </div>
            </div>
          </template>
        </generic-content-loader>


      </card>
    </div>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";

export default {
  inject: ["meta"],
  layout: "default",
  props: {
    // alias for fetching the article
    alias: {
      type: String,
      default: "",
    },
    // set meta  based on content?
    handleMeta: {
      type: Boolean,
      default: true,
    },
    // when fetchContent is false - get article from this property
    article: {
      type: Boolean,
      default: false,
    },
    // fetch content automatically?
    fetchContent: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  data: function () {
    let res = {};

    if (this.fetchContent) {
      res.item = false;
      res.asyncData = {
        item: {
          target: `content/article/${this.alias}`,
          options: {
            dataMutator: async (data) => {
              return data.item;
            },
            errorHandler: "404",
          },
        },
      };
    } else {
      res.item = this.article;
    }

    return res;
  },
  watch: {
    item(newVal) {
      if (
        utilities.hasOwnProperty(newVal, "meta") &&
        utilities.isObject(newVal.meta) &&
        this.handleMeta
      ) {
        this.setMetaByMetaObject(newVal.meta, this.meta);
      }
    },
  },
  methods: {
    isNonEmptyString(str) {
      return utilities.isNonEmptyString(str);
    },
  },
  serverPrefetch() {
    return this.getSSRPrefetchPromise();
  },
};
</script>

<style scoped lang="scss"></style>
